import { Fragment } from "react";
import { inputClasses } from "../../styles/inputs";

const RenderInput = ({ type, style, placeHolder, classes, attributes, onChange }) => {
    const inputClass = inputClasses();
    classes = classes.reduce((cls, c) => cls + " " + inputClass[c], "");

    return <input className={classes} type={type} style={style} placeholder={placeHolder} {...attributes} onChange={onChange} />;
}

export const Input = ({ type, style, placeHolder, classes = [], attributes, onChange }) => (
    <Fragment>
        <RenderInput {...{ type, style, placeHolder, classes: [...classes, "input"], attributes, onChange }} />
    </Fragment>
);